import template from './support-highlights.html';
export var SupportHighlightsComponent = {
    template: template,
    controller: /** @class */ (function () {
        function SupportHighlightsComponent($sce, NavbarService) {
            'ngInject';
            this.$sce = $sce;
            this.NavbarService = NavbarService;
        }
        SupportHighlightsComponent.prototype.$onInit = function () {
            this.highlightsContent = '';
            this.getHighlightsContent();
        };
        SupportHighlightsComponent.prototype.getHighlightsContent = function () {
            var _this = this;
            this.NavbarService.getContent(9030)
                .then(function (response) {
                if (response.data.response && response.data.response.detail) {
                    _this.highlightsContent = _this.$sce.trustAsHtml(response.data.response.detail);
                }
            })
                .catch(function () {
                _this.highlightsContent = "<h2>Error getting content</h2>";
            });
        };
        return SupportHighlightsComponent;
    }())
};
//# sourceMappingURL=support-highlights.component.js.map